<template>
  <v-card flat>
    <v-container :class="isMobile ? 'px-0' : ''">
      <v-row>
        <v-col :cols="isMobile ? 12 : 3" class="pb-0">
          <v-text-field
            label="Fecha prescripción"
            id="fechaPrescripcionVistaPrevia"
            variant="outlined"
            density="compact"
            style="color: #000"
            :model-value="datosVistaPrevia.selectedFechaEmision"
            :tabindex="isVistaPrevia ? 1 : -1"
            @keydown.tab="focusLastFieldOfCurrentStep"
            readonly
          ></v-text-field>
        </v-col>
        <v-col :cols="isMobile ? 12 : 5" class="pb-0">
          <v-text-field
            label="Apellido/s y nombre/s paciente"
            variant="outlined"
            density="compact"
            :model-value="datosVistaPrevia.pacienteApellidoNombre"
            :tabindex="isVistaPrevia ? 2 : -1"
            readonly
          ></v-text-field>
        </v-col>
        <v-col :cols="isMobile ? 12 : 4" class="pb-0">
          <v-text-field
            label="Email"
            variant="outlined"
            density="compact"
            :model-value="datosVistaPrevia.pacienteEmail"
            :tabindex="isVistaPrevia ? 3 : -1"
            readonly
          ></v-text-field>
        </v-col>
        <v-col :cols="isMobile ? 12 : 2" class="py-0">
          <v-text-field
            label="Tipo documento"
            variant="outlined"
            density="compact"
            :model-value="datosVistaPrevia.tipoDocValue"
            :tabindex="isVistaPrevia ? 4 : -1"
            readonly
          ></v-text-field>
        </v-col>
        <v-col :cols="isMobile ? 12 : 3" class="py-0">
          <v-text-field
            label="N° documento"
            variant="outlined"
            density="compact"
            :model-value="datosVistaPrevia.pacienteDocumento"
            :tabindex="isVistaPrevia ? 5 : -1"
            readonly
          ></v-text-field>
        </v-col>
        <v-col :cols="isMobile ? 12 : 3" class="py-0">
          <v-text-field
            label="CUIL"
            variant="outlined"
            density="compact"
            :model-value="datosVistaPrevia.pacienteCuil"
            :tabindex="isVistaPrevia ? 6 : -1"
            readonly
          ></v-text-field>
        </v-col>
        <v-col :cols="isMobile ? 12 : 2" class="py-0">
          <v-text-field
            label="Sexo"
            variant="outlined"
            density="compact"
            :model-value="datosVistaPrevia.generoValue"
            :tabindex="isVistaPrevia ? 7 : -1"
            readonly
          ></v-text-field>
        </v-col>
        <v-col :cols="isMobile ? 12 : 2" class="py-0">
          <v-text-field
            label="Fecha nacimiento"
            variant="outlined"
            density="compact"
            :model-value="datosVistaPrevia.selectedFechaNacimiento"
            :tabindex="isVistaPrevia ? 8 : -1"
            readonly
          ></v-text-field>
        </v-col>
        <v-col :cols="isMobile ? 12 : 4" class="py-0">
          <v-text-field
            label="Financiador"
            variant="outlined"
            density="compact"
            :model-value="datosVistaPrevia.financiadorValue"
            :tabindex="isVistaPrevia ? 9 : -1"
            readonly
          ></v-text-field>
        </v-col>
        <v-col
          :cols="isMobile ? 12 : 4"
          class="py-0"
          v-if="datosVistaPrevia.validaAfiliado"
        >
          <v-text-field
            label="Plan"
            variant="outlined"
            density="compact"
            :model-value="datosVistaPrevia.planValue"
            :tabindex="isVistaPrevia ? 10 : -1"
            readonly
          ></v-text-field>
        </v-col>
        <v-col :cols="isMobile ? 12 : 4" class="py-0" v-else>
          <v-text-field
            label="Plan"
            variant="outlined"
            density="compact"
            :model-value="datosVistaPrevia.planSelected"
            :tabindex="isVistaPrevia ? 10 : -1"
            readonly
          ></v-text-field>
        </v-col>
        <v-col :cols="isMobile ? 12 : 2" class="py-0">
          <v-text-field
            label="N° afiliado"
            variant="outlined"
            density="compact"
            :model-value="datosVistaPrevia.pacienteNumero"
            :tabindex="isVistaPrevia ? 11 : -1"
            readonly
          ></v-text-field>
        </v-col>
        <v-col :cols="isMobile ? 12 : 2" class="py-0">
          <v-text-field
            label="Teléfono"
            variant="outlined"
            density="compact"
            :model-value="datosVistaPrevia.pacienteTelefono"
            :tabindex="isVistaPrevia ? 12 : -1"
            readonly
          ></v-text-field>
        </v-col>
        <!-- Mostrar domicilio del paciente en Vista previa (solo lectura) -->
        <v-col cols="12" class="py-0" v-if="datosVistaPrevia.hasMedicamentoRestringido && datosVistaPrevia.domicilioPaciente">
          <v-textarea
            :model-value="datosVistaPrevia.domicilioPreviewDisplay"
            label="Domicilio paciente"
            variant="outlined"
            density="compact"
            :tabindex="isVistaPrevia ? 13 : -1"
            auto-grow
            rows="1"
            readonly
          ></v-textarea>
        </v-col>

        <v-col cols="12" class="py-0">
          <v-textarea
            :model-value="datosVistaPrevia.diagnostico"
            label="Diagnóstico"
            variant="outlined"
            density="compact"
            :tabindex="isVistaPrevia ? 14 : -1"
            auto-grow
            rows="1"
            readonly
          ></v-textarea>
        </v-col>
        <v-col cols="12" class="py-0">
          <v-data-table
            :mobile="isMobile"
            :hide-default-header="isMobile"
            :hide-no-data="isMobile"
            :items="datosVistaPrevia.medicamentosAgregados"
            item-value="id"
            density="compact"
            :headers="datosVistaPrevia.vistaPreviaHeadersMedicamentosAgregados"
          >
            <template #bottom></template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: "VistaPreviaMedicamento",
  props: {
    // Objeto con todos los datos de vista previa
    datosVistaPrevia: {
      type: Object,
      required: true
    },

    // Estado de UI
    isMobile: {
      type: Boolean,
      required: true
    },
    isVistaPrevia: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    focusLastFieldOfCurrentStep(event) {
      // Emitir evento para que el componente padre maneje el foco
      this.$emit('focusLastFieldOfCurrentStep', event);
    }
  }
};
</script>
